import API_ENDPOINTS from '../config/api';
import { get, post, put, del } from '../utils/api';

/**
 * Course API Service
 */

// Get all courses with optional filters
export const getAllCourses = async (params = {}) => {
  const queryParams = { isActive: 'true', ...params };
  const queryString = new URLSearchParams(queryParams).toString();
  const url = queryString 
    ? `${API_ENDPOINTS.courses}?${queryString}` 
    : API_ENDPOINTS.courses;
  return await get(url);
};

// Get course by ID
export const getCourseById = async (id) => {
  return await get(API_ENDPOINTS.courseById(id));
};

// Get course by path
export const getCourseByPath = async (path) => {
  return await get(API_ENDPOINTS.courseByPath(path));
};

// Get course categories
export const getCourseCategories = async () => {
  return await get(API_ENDPOINTS.courseCategories);
};

// Create course (Admin only)
export const createCourse = async (courseData) => {
  return await post(API_ENDPOINTS.courses, courseData);
};

// Update course (Admin only)
export const updateCourse = async (id, courseData) => {
  return await put(API_ENDPOINTS.courseById(id), courseData);
};

// Delete course (Admin only)
export const deleteCourse = async (id) => {
  return await del(API_ENDPOINTS.courseById(id));
};

const courseService = {
  getAllCourses,
  getCourseById,
  getCourseByPath,
  getCourseCategories,
  createCourse,
  updateCourse,
  deleteCourse,
};

export default courseService;
